// ** api slice import
import { slices } from '../../app/slice';

// ** api routes for tax files management
const routes = {
  ALL_TAX_FILES: '/tax-file/all',
  GET_TAX_FILE_STATS: '/tax-file/stats',
  GET_TAX_FILE: '/tax-file/:taxFileId',
  GET_TAX_FILE_BY_CUSTOMER_ID: '/tax-file/customer/',
  UPDATE_ANSWER: '/tax-file/:taxFileId/answers/:questionId',
  GET_TAX_FILE_HISTORY: '/tax-file/:taxFileId/history',
  ASSIGN_TAX_FILE: '/tax-file/:taxFileId/assign',
  ADD_NOTES: '/tax-file/:taxFileId/notes',
  GET_QUIZ_RESPONSE_BY_TAX_FILE_ID: '/tax-file/:taxFileId/quiz-response',
  ADD_TAX_FILE_HISTORY: '/tax-file/:taxFileId/history',
};

// ** slice for tax files management
const taxFilesApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    getAllTaxFiles: builder.query({
      query: query => ({
        url: routes.ALL_TAX_FILES,
        method: 'GET',
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getTaxFileStats: builder.query({
      query: () => ({
        url: routes.GET_TAX_FILE_STATS,
        method: 'GET',
      }),
    }),
    getTaxFile: builder.query({
      query: taxFileId => ({
        url: routes.GET_TAX_FILE.replace(':taxFileId', taxFileId),
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getTaxFileByCustomerId: builder.query({
      query: params => {
        const { customerId, ...query } = params;
        return {
          url: `${routes.GET_TAX_FILE_BY_CUSTOMER_ID}${customerId}`,
          method: 'GET',
          params: query,
        };
      },
    }),
    updateAnswer: builder.mutation({
      query: data => ({
        url: routes.UPDATE_ANSWER.replace(':taxFileId', data.taxFileId).replace(
          ':questionId',
          data.questionId
        ),
        method: 'PUT',
        body: data,
      }),
    }),
    getTaxFileHistory: builder.query({
      query: query => {
        const { taxFileId, ...rest } = query || {};
        return {
          url: routes.GET_TAX_FILE_HISTORY.replace(':taxFileId', taxFileId),
          method: 'GET',
          params: rest,
        };
      },
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    assignTaxFile: builder.mutation({
      query: data => ({
        url: routes.ASSIGN_TAX_FILE.replace(':taxFileId', data.taxFileId),
        method: 'PUT',
        body: data,
      }),
    }),
    addNotes: builder.mutation({
      query: data => ({
        url: routes.ADD_NOTES.replace(':taxFileId', data.taxFileId),
        method: 'POST',
        body: data.data,
      }),
    }),
    getQuizResponseByTaxFileId: builder.query({
      query: taxFileId => ({
        url: routes.GET_QUIZ_RESPONSE_BY_TAX_FILE_ID.replace(
          ':taxFileId',
          taxFileId
        ),
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    addTaxFileHistory: builder.mutation({
      query: data => ({
        url: routes.ADD_TAX_FILE_HISTORY.replace(':taxFileId', data.taxFileId),
        method: 'POST',
        body: data.data.data,
      }),
    }),
  }),
});

export const {
  useGetAllTaxFilesQuery,
  useGetTaxFileStatsQuery,
  useGetTaxFileQuery,
  useGetTaxFileByCustomerIdQuery,
  useUpdateAnswerMutation,
  useGetTaxFileHistoryQuery,
  useAssignTaxFileMutation,
  useAddNotesMutation,
  useGetQuizResponseByTaxFileIdQuery,
  useAddTaxFileHistoryMutation,
} = taxFilesApiSlice;
